module.exports = __webpack_public_path__ + "img/webnew29.585c9a67.jpg";